import { render, staticRenderFns } from "./ModalItensPedido.vue?vue&type=template&id=22fdd12e&"
import script from "./ModalItensPedido.vue?vue&type=script&lang=js&"
export * from "./ModalItensPedido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports